
import React, { useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';

import '../../../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';


const ipGetRequest = window.location.href;
// const myIP = ipGetRequest.split('/')[2].includes(':') ? ipGetRequest.split('/')[2].split(':')[0] : ipGetRequest.split('/')[2];
const myIP = ipGetRequest.split('/')[2];

function FormIPInterfaces(props) {
  // const { queueStats: { queue, completed, abandoned, total, calls, holdtime, talktime }, socketio } = props;
  const {  queue, socketio } = props;

  const [ queuesParams, setQueuesParams ] = useState({
    calls: 0,
    holdtime: 0,
    talktime: 0,
    completed: 0,
    abandoned: 0,
    total: 0
  });

  const getInitialQueueStats = async () => {
    const responseStats = await axios.post(`http://${myIP}/queues-data`, { queues: [ queue ] });
    let { data } = responseStats;
    data = data[`${queue}`];
    
    if (typeof data === 'undefined') return;
    setQueuesParams({ queue: data.queue, completed: data.completed, abandoned: data.abandoned, total: parseInt(data.completed) + parseInt(data.abandoned), calls: data.calls, holdtime: data.holdtime, talktime: data.talktime })
    return data;
  };

  const timeConvert = (time) => {
    let minutes = Math.floor(time / 60);
    let second = time % 60;

    minutes = minutes < 10 ? `0${minutes}` : minutes;
    second = second < 10 ? `0${second}` : second;

    return `${minutes}:${second}`
  };

  const loaddata = async () => await getInitialQueueStats();
  
  useEffect(async () => {
    await getInitialQueueStats();
  }, []);

  useEffect(() => {
    socketio.on(`${queue}`, async (data) => {
      if (data.event === 'QueueParams') setQueuesParams({ queue: data.queue, completed: data.completed, abandoned: data.abandoned, total: parseInt(data.completed) + parseInt(data.abandoned), calls: data.calls, holdtime: data.holdtime, talktime: data.talktime });
      
      if (data.event === 'QueueCallerLeave' && data.connectedlinenum !== '<unknown>') {
        setQueuesParams((prev) => {
          prev['total'] = Number(prev.total) + 1;
          prev['completed'] = Number(prev.completed) + 1;
          prev['calls'] = Number(data['count']);

          return prev;
        });
        setTimeout(() =>  loaddata(), 1000)
      }

      if (data.event === 'QueueCallerAbandon') loaddata();
      
      if (data.event === 'QueueCallerJoin') {
        setQueuesParams((prev) => {
          prev['calls'] = Number(prev['calls']) > 0 ? Number(prev['calls']) : data.count;
          return prev;
        });
        setTimeout(() =>  loaddata(), 300)
      }

      if (data.event === 'QueueMemberStatus') loaddata();
    });
  }, []);

  const { calls, holdtime, talktime, completed, abandoned, total } = queuesParams;
  return (
    <div className="column is-3">
      <h1 className="has-background-link-light has-text-centered"><strong>Estatísticas </strong></h1>
      <div className="ml-2 mt-2">
        Ch. em espera - <strong>{ calls }</strong>
      </div>
      <div className="ml-2">
        Média Espera - <strong>{ timeConvert(Number(holdtime)) }</strong>
      </div>
      <div className="ml-2">
        Média Ligação - <strong>{ timeConvert(Number(talktime)) }</strong>
      </div>
      <div className="ml-2">
        Atendidas - <strong>{ completed }</strong>
      </div>
        <div className="ml-2">
        Abandonadas - <strong>{ abandoned }</strong>
      </div>
      <div className="ml-2">
        Total Chamadas - <strong>{ total }</strong>
      </div>
    </div>
  );
}

export default FormIPInterfaces;
